import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "checkbox-indeterminate-icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.69238 12C7.69238 11.5858 8.02817 11.25 8.44238 11.25L15.4873 11.25C15.9015 11.25 16.2373 11.5858 16.2373 12C16.2373 12.4142 15.9015 12.75 15.4873 12.75L8.44238 12.75C8.02817 12.75 7.69238 12.4142 7.69238 12Z"
    }, null, -1)
  ])))
}
export default { render: render }